export default __webpack_public_path__ + "static/media/asterisk.2260d58d.svg";